<div class="bg-m1 flex h-full cursor-default flex-col">
  <ng-template #templateExplorer>
    <div *ngIf="isExplorer === false">Explorer role required</div>
  </ng-template>

  <div class="flex h-2 flex-1 flex-row">
    <div class="mx-6 mb-6 mt-8 flex min-w-[2px] flex-grow flex-col">
      <div
        class="flex flex-row items-center justify-between"
        [ngClass]="{
          'h-11':
            fractions.length === 0 ||
            [fractionTypeEnum.TsIsBetween].indexOf(fractions[0].type) < 0,
          'h-[100px]':
            [fractionTypeEnum.TsIsBetween].indexOf(fractions[0].type) > -1
        }"
      >
        <div class="flex w-full flex-row items-center">
          <div
            class="flex w-1/5 flex-shrink-0 flex-row items-center justify-between"
          >
            <div class="flex w-full flex-row items-center">
              <div
                data-cy="metricsTitle"
                class="text-s1 flex select-none items-center self-center text-2xl font-semibold"
              >
                {{ pageTitle }}
              </div>

              <m-left-panel-icon
                class="text-s500 ml-5 flex-shrink-0 cursor-pointer"
                (click)="toggleShowLeft()"
                [isFilled]="isShowLeft === true"
              ></m-left-panel-icon>

              <div
                class="ml-5 flex w-[120px] flex-shrink-0 cursor-pointer flex-row items-center justify-center"
                (click)="navToReportsList()"
              >
                <!-- <m-view-list-icon
                  [ngClass]="{
                    'text-m500': lastUrl === pathReportsList,
                    'text-s400': lastUrl !== pathReportsList
                  }"
                ></m-view-list-icon> -->

                <div
                  class="select-none items-center text-lg"
                  [ngClass]="{
                    'text-m500 font-semibold': lastUrl === pathReportsList,
                    'text-s500': lastUrl !== pathReportsList
                  }"
                >
                  Reports List
                </div>
              </div>

              <div
                class="flex flex-1 flex-row items-center justify-center"
              ></div>

              <div
                [tp]="templateExplorer"
                [tpIsEnabled]="isExplorer === false"
                class="ml-5"
              >
                <button
                  type="button"
                  data-cy="metricsNewReportButton"
                  class="text-m0 h-11 flex-shrink-0 select-none rounded px-5 py-2 text-base font-medium focus:outline-none"
                  [ngClass]="{
                    'bg-m600': isExplorer === true,
                    'bg-s400 cursor-default': isExplorer === false
                  }"
                  (click)="newReport()"
                  [disabled]="isExplorer === false"
                  >New Report</button
                >
              </div>
            </div>

            <!-- <button
            class="ml-2 flex h-9 select-none items-center justify-center rounded border border-2 w-[36px] py-3 text-lg font-semibold focus:outline-none"
            [ngClass]="{
              'text-m500':
                timeSpecForm.controls['timeSpec'].value === timeSpecTimestamps,
              'border-transparent text-s500':
                timeSpecForm.controls['timeSpec'].value !== timeSpecTimestamps
            }"
            (click)="timeSpecChange(timeSpecTimestamps)"
            >T</button
          > -->

            <!-- <button
            class="ml-2 flex h-9 select-none items-center justify-center rounded border border-2 w-[36px] py-3 text-lg font-semibold focus:outline-none"
            [ngClass]="{
              'text-m500':
                timeSpecForm.controls['timeSpec'].value === timeSpecMinutes,
              'border-transparent text-s500':
                timeSpecForm.controls['timeSpec'].value !== timeSpecMinutes
            }"
            (click)="timeSpecChange(timeSpecMinutes)"
            >M</button
          > -->

            <!-- <button
            class="ml-2 flex h-9 select-none items-center justify-center rounded border border-2 w-[36px] py-3 text-lg font-semibold focus:outline-none"
            [ngClass]="{
              'text-m500':
                timeSpecForm.controls['timeSpec'].value === timeSpecHours,
              'border-transparent text-s500':
                timeSpecForm.controls['timeSpec'].value !== timeSpecHours
            }"
            (click)="timeSpecChange(timeSpecHours)"
            >H</button
          > -->

            <!-- <button
                class="ml-5 flex h-9 w-[36px] select-none items-center justify-center rounded border border-2 py-3 text-lg font-semibold focus:outline-none"
                [ngClass]="{
                  'text-m500':
                    timeSpecForm.controls['timeSpec'].value ===
                    timeSpecTimestamps,
                  'border-transparent text-s500':
                    timeSpecForm.controls['timeSpec'].value !==
                    timeSpecTimestamps
                }"
                (click)="timeSpecChange(timeSpecTimestamps)"
              >
                <div> T </div>
              </button> -->

            <!-- <button
                class="ml-2 flex h-9 w-[36px] select-none items-center justify-center rounded border border-2 py-3 text-lg font-semibold focus:outline-none"
                [ngClass]="{
                  'text-m500':
                    timeSpecForm.controls['timeSpec'].value ===
                    timeSpecQuarters,
                  'border-transparent text-s500':
                    timeSpecForm.controls['timeSpec'].value !== timeSpecQuarters
                }"
                (click)="timeSpecChange(timeSpecQuarters)"
                >Q</button
              > -->

            <!-- <button
                class="ml-2 flex h-9 w-[36px] select-none items-center justify-center rounded border border-2 py-3 text-lg font-semibold focus:outline-none"
                [ngClass]="{
                  'text-m500':
                    timeSpecForm.controls['timeSpec'].value === timeSpecYears,
                  'border-transparent text-s500':
                    timeSpecForm.controls['timeSpec'].value !== timeSpecYears
                }"
                (click)="timeSpecChange(timeSpecYears)"
                >Y</button
              > -->

            <!-- <button
                class="ml-5 flex h-9 w-[36px] select-none items-center justify-center rounded border border-2 py-3 text-lg font-semibold focus:outline-none"
                [ngClass]="{
                  'text-m500':
                    timeSpecForm.controls['timeSpec'].value === timeSpecDays,
                  'border-transparent text-s500':
                    timeSpecForm.controls['timeSpec'].value !== timeSpecDays
                }"
                (click)="timeSpecChange(timeSpecDays)"
              >
                <div> D </div>
              </button> -->

            <!-- <button
                class="ml-2 flex h-9 w-[36px] select-none items-center justify-center rounded border border-2 py-3 text-lg font-semibold focus:outline-none"
                [ngClass]="{
                  'text-m500':
                    timeSpecForm.controls['timeSpec'].value === timeSpecWeeks,
                  'border-transparent text-s500':
                    timeSpecForm.controls['timeSpec'].value !== timeSpecWeeks
                }"
                (click)="timeSpecChange(timeSpecWeeks)"
                >W</button
              > -->

            <!-- <button
                class="ml-2 flex h-9 w-[36px] select-none items-center justify-center rounded border border-2 py-3 text-lg font-semibold focus:outline-none"
                [ngClass]="{
                  'text-m500':
                    timeSpecForm.controls['timeSpec'].value === timeSpecMonths,
                  'border-transparent text-s500':
                    timeSpecForm.controls['timeSpec'].value !== timeSpecMonths
                }"
                (click)="timeSpecChange(timeSpecMonths)"
                >M</button
              > -->
          </div>

          <div
            *ngIf="lastUrl !== pathReports && lastUrl !== pathReportsList"
            class="flex w-full select-none flex-row items-center"
          >
            <div class="text-s1 ml-[44px] select-none text-xl font-semibold"
              >Detail</div
            >

            <form class="ml-6" [formGroup]="timeSpecForm">
              <ng-select
                #timeSpecSelect
                [fixNgSelectBottom]="timeSpecSelect"
                data-cy="timeSpecSelect"
                class="popup-55 w-[150px]"
                [items]="timeSpecList"
                [clearable]="false"
                [searchable]="false"
                (change)="timeSpecChange()"
                (keyup.esc)="
                  $event.stopImmediatePropagation(); timeSpecSelect.blur()
                "
                (keyup.enter)="
                  $event.stopImmediatePropagation(); timeSpecSelect.blur()
                "
                appendTo="body"
                bindLabel="label"
                bindValue="value"
                formControlName="timeSpec"
              >
                <ng-template ng-label-tmp let-item="item">
                  <div class="ml-1 truncate">{{ item.label }}</div>
                </ng-template>

                <ng-template ng-option-tmp let-item="item">
                  <div class="ml-1 truncate">{{ item.label }}</div>
                </ng-template>
              </ng-select>
            </form>

            <div class="text-s1 ml-6 select-none text-base">Time</div>

            <div
              class="flex flex-row items-center justify-start"
              *ngFor="let fraction of fractions"
            >
              <m-fraction-ts
                class="ml-4 mt-[28px]"
                [fraction]="fraction"
                [timeSpec]="timeSpecForm.controls['timeSpec'].value"
                [isFirst]="true"
                [isMetrics]="true"
                [fractionIndex]="0"
                (fractionUpdate)="fractionUpdate($event)"
              ></m-fraction-ts>
            </div>

            <div
              class="text-a500 ml-4 flex h-8 w-8 flex-shrink-0"
              tp="Exceeded time columns limit ({{
                report.timeColumnsLimit
              }}). Change time detail or reduce time filter window."
              *ngIf="report?.isTimeColumnsLimitExceeded === true"
            >
              <m-exclamation-icon></m-exclamation-icon>
            </div>

            <div
              class="text-r1 ml-4 flex h-8 w-8 flex-shrink-0"
              tp="The left boundary value of the time range must be less than the right boundary value"
              *ngIf="
                report?.timeRangeFraction?.type === fractionTypeTsIsBetween &&
                report?.rangeStart >= report?.rangeEnd
              "
            >
              <m-exclamation-icon></m-exclamation-icon>
            </div>

            <div class="flex flex-grow"></div>

            <m-query-status
              *ngIf="!!lastCompletedQuery"
              class="ml-5 min-w-[2px]"
              [query]="lastCompletedQuery"
              [showDataRowsLength]="false"
              [showLastCompleteDuration]="false"
              [completedWord]="'Completed'"
            ></m-query-status>

            <div class="flex flex-shrink-0 flex-row items-center">
              <div
                class="ml-7 flex cursor-pointer flex-row items-center"
                (click)="toggleAutoRun()"
              >
                <ui-switch
                  class="mt-1"
                  [checked]="isAutoRun"
                  color="#64BD63"
                ></ui-switch>

                <div
                  class="text-s1 ml-5 flex h-9 flex-shrink-0 select-none items-center text-base"
                  >Auto Run</div
                >
              </div>

              <ng-template #templateAutoRunSelector>
                <div *ngIf="alias === restrictedUserAlias"
                  >Demo user is restricted</div
                >

                <div
                  *ngIf="alias !== restrictedUserAlias && isAutoRun === false"
                  >Enable Auto Run to use selector</div
                >
              </ng-template>

              <div
                class="ml-5 flex flex-col items-stretch"
                [tp]="templateAutoRunSelector"
                [tpIsEnabled]="
                  alias === restrictedUserAlias || isAutoRun === false
                "
              >
                <div
                  *ngIf="
                    isAutoRun === true &&
                    alias !== restrictedUserAlias &&
                    refreshForm.controls['refresh'].value !== 0
                  "
                  class="h-[6px] w-full"
                ></div>

                <form [formGroup]="refreshForm">
                  <ng-select
                    #refreshSelect
                    [fixNgSelectBottom]="refreshSelect"
                    data-cy="refreshSelect"
                    class="popup-55 w-[100px] select-none"
                    [items]="refreshList"
                    [clearable]="false"
                    [searchable]="false"
                    (change)="refreshChange()"
                    (keyup.esc)="
                      $event.stopImmediatePropagation(); refreshSelect.blur()
                    "
                    (keyup.enter)="
                      $event.stopImmediatePropagation(); refreshSelect.blur()
                    "
                    appendTo="body"
                    bindLabel="label"
                    bindValue="value"
                    formControlName="refresh"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      <div class="ml-1 truncate">{{
                        alias !== restrictedUserAlias ? item.label : ''
                      }}</div>
                    </ng-template>

                    <ng-template ng-option-tmp let-item="item">
                      <div class="ml-1 truncate">{{ item.label }}</div>
                    </ng-template>
                  </ng-select>
                </form>

                <div
                  *ngIf="
                    isAutoRun === true &&
                    alias !== restrictedUserAlias &&
                    refreshForm.controls['refresh'].value !== 0
                  "
                  class="bg-s200 h-[6px] w-full overflow-hidden rounded-full"
                >
                  <div
                    class="bg-g1 h-full transition-all duration-[50ms] ease-linear"
                    [style.width.%]="refreshProgress"
                  >
                  </div>
                </div>
              </div>

              <button
                type="button"
                data-cy="metricsRunButton"
                class="text-m0 ml-6 mr-9 flex h-12 w-24 select-none items-center justify-center rounded text-base font-medium focus:outline-none"
                [ngClass]="{
                  'bg-m600':
                    notEmptySelectQueriesLength > 0 &&
                    (report?.rangeStart < report?.rangeEnd ||
                      report?.timeRangeFraction?.type !==
                        fractionTypeTsIsBetween),
                  'cursor-default':
                    notEmptySelectQueriesLength === 0 ||
                    isRunButtonPressed === true ||
                    (report?.rangeStart >= report?.rangeEnd &&
                      report?.timeRangeFraction?.type ===
                        fractionTypeTsIsBetween),
                  'bg-s400':
                    notEmptySelectQueriesLength === 0 ||
                    (report?.timeRangeFraction?.type ===
                      fractionTypeTsIsBetween &&
                      report?.rangeStart >= report?.rangeEnd)
                }"
                (click)="run()"
                [disabled]="
                  notEmptySelectQueriesLength === 0 ||
                  isRunButtonPressed === true ||
                  (report?.timeRangeFraction?.type ===
                    fractionTypeTsIsBetween &&
                    report?.rangeStart >= report?.rangeEnd)
                "
              >
                <div *ngIf="isRunButtonPressed === false">Run</div>
                <div
                  *ngIf="isRunButtonPressed === true"
                  class="relative flex h-9 w-9 flex-shrink-0"
                >
                  <ngx-spinner
                    [name]="metricsRunButtonSpinnerName"
                    color="#FFFFFF"
                    bdColor="#00000000"
                    size="default"
                    type="ball-clip-rotate"
                    [fullScreen]="false"
                    [disableAnimation]="true"
                    [zIndex]="10"
                  >
                  </ngx-spinner>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-6 flex h-2 flex-1 flex-row">
        <div class="flex w-1/5 flex-shrink-0" *ngIf="isShowLeft === true">
          <div class="bg-m0 flex w-full flex-grow rounded shadow">
            <div class="text-s1 mt-[30px] flex w-full flex-col text-base">
              <div
                class="text-s1 mb-[18px] flex h-11 w-full flex-shrink-0 flex-row items-center"
              >
                <div
                  (click)="setShowReports()"
                  class="ml-6 flex cursor-pointer select-none flex-row items-center pl-0 pr-2 text-lg"
                >
                  <div
                    class="flex w-[90px] flex-row items-center justify-center"
                  >
                    <div
                      [ngClass]="{
                        'text-s400': showMetrics === true,
                        'font-semibold': showMetrics === false
                      }"
                    >
                      REPORTS
                    </div>
                  </div>
                </div>

                <div
                  class="ml-2 flex select-none flex-row items-center text-lg"
                  [tp]="templateExplorer"
                  [tpIsEnabled]="isExplorer === false"
                >
                  <div
                    class="flex w-[94px] flex-row items-center justify-center pl-2"
                    (click)="setShowMetrics()"
                  >
                    <div
                      [ngClass]="{
                        'cursor-pointer': isExplorer !== false,
                        'text-s400': showMetrics === false,
                        'font-semibold':
                          isExplorer !== false && showMetrics === true
                      }"
                    >
                      METRICS
                    </div>
                  </div>
                </div>
              </div>

              <div class="divide-s300 ml-6 mr-9 flex flex-col divide-y">
                <div class="flex flex-row"></div>
                <div class="flex flex-row"></div>
              </div>

              <div
                *ngIf="showMetrics === false"
                class="flex h-2 flex-1 flex-col"
              >
                <div class="mb-5 mt-5 flex h-11 flex-row items-center">
                  <m-search-icon class="text-s1 ml-6"></m-search-icon>

                  <input
                    spellcheck="false"
                    autocomplete="off"
                    data-cy="reportsSearchReportsInput"
                    class="form-input focus:border-m600 border-s400 ml-3 h-10 w-[225px] select-none rounded"
                    placeholder="Search Reports"
                    [ngClass]="{
                      'bg-p200': !!searchReportsWord
                    }"
                    [(ngModel)]="searchReportsWord"
                    (ngModelChange)="searchReportsWordChange()"
                  />

                  <div class="h-9 w-9">
                    <m-delete-icon
                      *ngIf="!!searchReportsWord"
                      class="text-s1 ml-3 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                      [ngClass]="{
                        'bg-p200 hover:bg-p300 cursor-pointer':
                          !!searchReportsWord
                      }"
                      (click)="resetReportsSearch()"
                    ></m-delete-icon>
                  </div>

                  <div class="flex flex-grow"></div>

                  <button
                    *ngIf="
                      filteredDraftsLength > 0 && alias !== restrictedUserAlias
                    "
                    class="ml-3 mr-10 flex select-none flex-row items-center rounded border px-4 py-2 focus:outline-none"
                    [ngClass]="{
                      'border-s400 text-s500 hover:bg-s100':
                        filteredDraftsLength > 0,
                      'border-s300 text-s400 cursor-default':
                        filteredDraftsLength === 0
                    }"
                    [disabled]="filteredDraftsLength === 0"
                    (click)="deleteDrafts()"
                  >
                    <m-trash-icon></m-trash-icon>
                    <div class="ml-3">Drafts</div>
                  </button>
                </div>

                <div class="divide-s300 ml-6 mr-9 flex flex-col divide-y">
                  <div class="flex flex-row"></div>
                  <div class="flex flex-row"></div>
                </div>

                <div class="flex h-2 flex-1 flex-col">
                  <div
                    #leftReportsContainer
                    class="flex h-2 flex-grow flex-col overflow-y-auto"
                    [ngClass]="{
                      visible: isInitialScrollCompleted === true,
                      invisible: isInitialScrollCompleted === false
                    }"
                  >
                    <ng-scrollbar
                      [orientation]="'vertical'"
                      [visibility]="'hover'"
                      [appearance]="'compact'"
                    >
                      <div class="h-[12px]"></div>

                      <div
                        *ngFor="let r of filteredReports; let i = index"
                        [attr.reportId]="r.reportId"
                      >
                        <div
                          *ngIf="filteredDraftsLength > 0 && i === 0"
                          class="mb-4 ml-[24px] mr-[36px] mt-4 flex select-none flex-row justify-start font-semibold"
                          [ngClass]="{
                            'text-s400': alias === restrictedUserAlias,
                            'text-s500': alias !== restrictedUserAlias
                          }"
                        >
                          {{
                            alias === restrictedUserAlias
                              ? 'Drafts are hidden for Demo User'
                              : 'Drafts'
                          }}
                        </div>

                        <div
                          *ngIf="
                            alias !== restrictedUserAlias && r.draft === true
                          "
                          class="hover:bg-m50 group ml-6 mr-5 flex h-11 flex-row items-center rounded pr-2 hover:cursor-pointer"
                          (click)="navToReport(r)"
                          [ngClass]="{
                            'bg-m50': r.reportId === report.reportId,
                            'mt-4': i === 0
                          }"
                        >
                          <div class="ml-4 mr-3 flex h-2 items-center">
                            <div
                              *ngIf="r.reportId === report?.reportId"
                              data-cy="reportsSelectedSymbol"
                              class="bg-m600 text-m0 h-9 w-[6px] focus:outline-none"
                            ></div>

                            <div
                              *ngIf="r.reportId !== report?.reportId"
                              class="h-9 w-[6px]"
                            ></div>
                          </div>

                          <div
                            class="ml-1 select-none truncate"
                            [ngClass]="{
                              'text-m600 font-semibold':
                                r.reportId === report.reportId,
                              'text-s1': r.reportId !== report.reportId
                            }"
                          >
                            {{ r.title | capitalize }}
                          </div>

                          <div class="flex flex-grow"></div>

                          <div
                            tp="Explorer role required"
                            [tpIsEnabled]="isExplorer === false"
                          >
                            <button
                              *ngIf="
                                report.draft === true &&
                                r.reportId === report.reportId
                              "
                              data-cy="reportsSaveDraftButton"
                              class="ml-3 flex h-11 items-center justify-center rounded focus:outline-none"
                              (click)="reportSaveAs($event)"
                              [disabled]="isExplorer === false"
                            >
                              <div
                                class="hover:bg-m200 flex h-9 w-9 flex-shrink-0 flex-row items-center justify-center rounded px-2"
                              >
                                <m-save-icon
                                  [ngClass]="{
                                    'text-s500': isExplorer === true,
                                    'text-s400': isExplorer === false
                                  }"
                                ></m-save-icon>
                              </div>
                            </button>
                          </div>

                          <button
                            *ngIf="
                              report.draft === true &&
                              r.reportId === report.reportId
                            "
                            data-cy="reportsDeleteDraftButton"
                            class="hover:bg-m200 text-s500 ml-3 flex h-9 flex-shrink-0 items-center justify-center rounded px-2 focus:outline-none"
                            (click)="deleteDraftReport($event, r)"
                          >
                            <m-trash-icon></m-trash-icon>
                          </button>
                        </div>
                      </div>

                      <div
                        class="mb-4 ml-[24px] mr-[36px] mt-4 flex select-none flex-row items-center justify-start"
                      >
                        <button
                          class="text-s500 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                          type="button"
                          tp="Fold"
                          (click)="collapseReportsTree()"
                        >
                          <m-folder-minus-icon></m-folder-minus-icon>
                        </button>
                        <div class="text-s500 ml-[12px] font-semibold"
                          >Saved Reports</div
                        >

                        <button
                          class="ml-4 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                          type="button"
                          (click)="
                            setFavoritesOnly({
                              event: $event,
                              favoritesOnly: !favoritesOnly
                            })
                          "
                          [ngClass]="{
                            'text-m500': favoritesOnly === true,
                            'text-s500': favoritesOnly === false
                          }"
                        >
                          <m-star-icon
                            [isFilled]="favoritesOnly === true"
                          ></m-star-icon>

                          <!-- <div class="ml-2 text-base"> Stars </div> -->
                        </button>
                      </div>

                      <div *ngIf="filteredReportNodes?.length > 0" class="ml-6">
                        <tree-root
                          class="h-2 w-full select-none"
                          #reportsTree
                          [nodes]="filteredReportNodes"
                          [options]="treeOptions"
                        >
                          <ng-template #treeNodeTemplate let-node="node">
                            <div
                              *ngIf="node.data.type === 'spaceFolder'"
                              class="group/bar flex h-11 w-full select-none flex-row rounded pr-5 hover:cursor-pointer"
                              (click)="reportTreeNodeOnClick({ node: node })"
                            >
                              <div
                                class="hover:bg-m50 relative flex w-full flex-row items-center rounded pl-2"
                                [style.padding-left.px]="(node.level - 1) * 12"
                              >
                                <div
                                  class="ml-2 flex flex-shrink-0 flex-row space-x-1"
                                >
                                  <div
                                    class="h-6 w-6"
                                    *ngIf="node.hasChildren === false"
                                  ></div>

                                  <m-chevron-right-icon
                                    class="text-s500"
                                    *ngIf="!node.isExpanded && node.hasChildren"
                                  ></m-chevron-right-icon>

                                  <m-chevron-down-icon
                                    class="text-s500"
                                    *ngIf="node.isExpanded && node.hasChildren"
                                  ></m-chevron-down-icon>

                                  <m-folder-closed-icon
                                    class="text-m500"
                                    *ngIf="
                                      !node.isExpanded || !node.hasChildren
                                    "
                                  ></m-folder-closed-icon>

                                  <m-folder-open-icon
                                    class="text-m600"
                                    *ngIf="node.isExpanded && node.hasChildren"
                                  ></m-folder-open-icon>
                                </div>

                                <div
                                  class="ml-3 flex min-w-[2px] flex-1 truncate"
                                >
                                  <span
                                    class="text-s1 truncate text-base"
                                    [ngClass]="{
                                      'font-semibold':
                                        node.data.isSelectedAncestor === true
                                    }"
                                    >{{
                                      node.data.isSynthetic === true
                                        ? node.data.title
                                        : (node.data.title | capitalize)
                                    }}</span
                                  >
                                </div>

                                <div
                                  *ngIf="node.data.isSynthetic !== true"
                                  class="invisible ml-2 flex pr-2 group-hover/bar:visible"
                                >
                                  <m-space-options
                                    [spaceFolder]="node.data"
                                  ></m-space-options>
                                </div>
                              </div>
                            </div>

                            <div
                              *ngIf="node.data.type === 'spaceUnit'"
                              [attr.reportId]="node.data.unitId"
                              class="hover:bg-m50 group mr-5 flex h-11 flex-row items-center rounded pr-2 hover:cursor-pointer"
                              (click)="reportTreeNodeOnClick({ node: node })"
                              [style.padding-left.px]="(node.level - 1) * 12"
                              [ngClass]="{
                                'bg-m50': node.data.unitId === report.reportId
                              }"
                            >
                              <div class="ml-4 mr-3 flex h-2 items-center">
                                <div
                                  *ngIf="node.data.unitId === report?.reportId"
                                  data-cy="reportsSelectedSymbol"
                                  class="bg-m600 text-m0 h-9 w-[6px] focus:outline-none"
                                ></div>

                                <div
                                  *ngIf="node.data.unitId !== report?.reportId"
                                  class="h-9 w-[6px]"
                                ></div>
                              </div>

                              <div
                                class="ml-1 select-none truncate"
                                [ngClass]="{
                                  'text-m600 font-semibold':
                                    node.data.unitId === report.reportId,
                                  'text-s1':
                                    node.data.unitId !== report.reportId
                                }"
                              >
                                {{ node.data.title | capitalize }}
                              </div>

                              <div class="flex flex-grow"></div>

                              <button
                                class="ml-2 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded focus:outline-none group-hover:visible"
                                type="button"
                                (click)="
                                  toggleFavoriteReport({
                                    event: $event,
                                    reportId: node.data.unitId
                                  })
                                "
                                [ngClass]="{
                                  'text-s300': node.data.isFavorite === true,
                                  'text-s400': node.data.isFavorite !== true
                                }"
                                [class.invisible]="
                                  favoritesOnly === true ||
                                  node.data.isFavorite !== true
                                "
                              >
                                <m-star-icon
                                  [isFilled]="node.data.isFavorite === true"
                                ></m-star-icon>
                              </button>

                              <div
                                class="invisible ml-2 flex group-hover:visible"
                              >
                                <m-report-options
                                  [spaceUnit]="node.data"
                                  [isHoverM]="false"
                                ></m-report-options>
                              </div>
                            </div>
                          </ng-template>
                        </tree-root>
                      </div>

                      <div
                        *ngIf="filteredReportNodes?.length === 0"
                        class="text-s1 flex select-none justify-center px-6 py-8 text-[17px]"
                      >
                        {{
                          !!searchReportsWord
                            ? 'Search results are empty'
                            : favoritesOnly === true
                              ? 'Favorites are empty'
                              : 'Reports are empty'
                        }}
                      </div>
                    </ng-scrollbar>
                  </div>
                </div>
              </div>

              <div
                *ngIf="showMetrics === true"
                class="flex h-2 flex-1 flex-col"
              >
                <div class="mb-5 mt-5 flex h-11 flex-row items-center">
                  <m-search-icon class="text-s1 ml-6"></m-search-icon>

                  <input
                    spellcheck="false"
                    autocomplete="off"
                    data-cy="reportsSearchMetricsInput"
                    class="form-input focus:border-m600 border-s400 ml-3 h-10 w-[225px] rounded"
                    placeholder="Search Metrics"
                    [ngClass]="{
                      'bg-p200': !!searchMetricsWord
                    }"
                    [(ngModel)]="searchMetricsWord"
                    (ngModelChange)="searchMetricsWordChange()"
                  />

                  <div class="h-9 w-9">
                    <m-delete-icon
                      *ngIf="!!searchMetricsWord"
                      class="text-s1 ml-3 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                      [ngClass]="{
                        'bg-p200 hover:bg-p300 cursor-pointer':
                          !!searchMetricsWord
                      }"
                      (click)="resetMetricsSearch()"
                    ></m-delete-icon>
                  </div>
                </div>

                <div class="divide-s300 ml-6 mr-9 flex flex-col divide-y">
                  <div class="flex flex-row"></div>
                  <div class="flex flex-row"></div>
                </div>

                <div class="flex h-2 flex-1 flex-col">
                  <m-metrics-tree class="flex flex-1"></m-metrics-tree>
                </div>
              </div>

              <div class="divide-s300 ml-6 mr-9 flex flex-col divide-y">
                <div class="flex flex-row"></div>
                <div class="flex flex-row"></div>
              </div>

              <div class="mb-5 mr-10 mt-5 flex h-11 flex-row items-center">
                <div class="text-s1 ml-6 select-none text-base">Timezone</div>

                <div class="ml-5 flex max-w-[260px] flex-1">
                  <form
                    class="w-full"
                    [formGroup]="timezoneForm"
                    tp="Timezone change is not allowed"
                    [tpIsEnabled]="
                      timezoneForm.controls['timezone'].disabled === true
                    "
                  >
                    <ng-select
                      #metricsTimezoneSelect
                      [fixNgSelectBottom]="metricsTimezoneSelect"
                      data-cy="metricsTimezoneSelect"
                      class="w-full select-none text-base"
                      [items]="timezones"
                      [clearable]="false"
                      [searchable]="true"
                      [searchFn]="timezoneSearchFn"
                      (change)="timezoneChange()"
                      (keyup.esc)="
                        $event.stopImmediatePropagation();
                        metricsTimezoneSelect.blur()
                      "
                      (keyup.enter)="
                        $event.stopImmediatePropagation();
                        metricsTimezoneSelect.blur()
                      "
                      appendTo="body"
                      bindLabel="label"
                      bindValue="value"
                      formControlName="timezone"
                    >
                      <ng-template ng-label-tmp let-item="item">
                        <div class="truncate">{{ item.label }}</div>
                      </ng-template>

                      <ng-template ng-option-tmp let-item="item">
                        <div class="truncate">{{ item.label }}</div>
                      </ng-template>
                    </ng-select>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          *ngIf="lastUrl === pathReports"
          class="ml-6 flex min-w-[2px] flex-grow flex-col"
        >
          <div
            class="text-s1 mb-[80px] flex h-full w-full select-none items-center justify-center text-xl"
          >
            Select Report
          </div>
        </div>

        <div *ngIf="lastUrl === pathReportsList" class="flex flex-1 flex-col">
          <div
            class="flex h-full flex-grow"
            [ngClass]="{
              'ml-6': isShowLeft === true
            }"
          >
            <div class="h-full w-full">
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>

        <div
          *ngIf="lastUrl !== pathReports && lastUrl !== pathReportsList"
          class="flex min-w-[2px] flex-grow flex-col"
          [ngClass]="{
            'ml-6': isShowLeft === true
          }"
        >
          <div class="divide-s300 divide-y">
            <div></div>
            <div></div>
          </div>

          <div class="mr-5 mt-6 flex min-h-[68px] flex-shrink-0 flex-row">
            <div
              (click)="toggleFiltersPanel()"
              class="text-s1 mt-2 flex h-11 select-none flex-row items-start space-x-2 px-5 text-xl font-semibold"
              [ngClass]="{
                'cursor-pointer': report?.fields.length > 0,
                'cursor-default': report?.fields.length === 0
              }"
            >
              <div class="flex flex-row items-center space-x-2">
                <m-chevron-right-icon
                  *ngIf="!filtersIsExpanded && report?.fields.length > 0"
                ></m-chevron-right-icon>
                <m-chevron-down-icon
                  *ngIf="filtersIsExpanded && report?.fields.length > 0"
                ></m-chevron-down-icon>

                <div class="h-6 w-6" *ngIf="report?.fields.length === 0"></div>

                <div> Parameters </div>
              </div>
            </div>

            <div class="ml-3 flex max-h-[270px] w-full flex-col overflow-auto">
              <div
                class="mr-5 mt-1 flex flex-row items-start"
                *ngIf="!filtersIsExpanded && report?.fields.length > 0"
              >
                <m-bricks
                  class="mb-5 flex max-h-[150px] max-w-max cursor-pointer flex-row items-start justify-start overflow-auto"
                  [extendedFilters]="report?.extendedFilters"
                  [metricsStartDateYYYYMMDD]="report?.metricsStartDateYYYYMMDD"
                  [metricsEndDateExcludedYYYYMMDD]="
                    report?.metricsEndDateExcludedYYYYMMDD
                  "
                  [metricsEndDateIncludedYYYYMMDD]="
                    report?.metricsEndDateIncludedYYYYMMDD
                  "
                  [isKeepBackgroundColor]="false"
                  (click)="toggleFiltersPanel()"
                ></m-bricks>
              </div>

              <div
                class="flex w-full flex-row"
                *ngIf="
                  filtersIsExpanded === true || report?.fields.length === 0
                "
              >
                <button
                  type="button"
                  data-cy="metricsAddFilterButton"
                  class="border-s400 text-s500 hover:bg-m0 h-11 flex-shrink-0 select-none rounded border px-4 py-2 text-base font-medium focus:outline-none"
                  (click)="addFilter()"
                  >Add Filter</button
                >

                <div
                  class="ml-7 mt-1 w-2 flex-1"
                  *ngIf="
                    filtersIsExpanded === true && report?.fields.length > 0
                  "
                >
                  <m-report-filters [report]="report"></m-report-filters>
                </div>
              </div>
            </div>
          </div>

          <div class="bg-m0 w-full flex-1 flex-shrink-0 rounded shadow">
            <router-outlet></router-outlet>
          </div>

          <div
            *ngIf="showMetricsChart === true || reportSelectedNodes.length > 0"
            class="mt-8 flex w-full flex-col"
            [ngClass]="{
              'mt-1 h-[40%]':
                showMetricsChart === true || reportSelectedNodes.length > 0
            }"
          >
            <div
              class="flex h-2 w-full flex-grow flex-row rounded"
              *ngIf="isShow === true && reportSelectedNodes.length > 0"
            >
              <m-row class="ml-5 mr-5 flex w-full"></m-row>
            </div>

            <div
              class="bg-m0 relative h-2 w-full flex-grow flex-row rounded shadow"
              *ngIf="
                isShow === true &&
                showMetricsChart === true &&
                reportSelectedNodes.length === 0
              "
            >
              <div class="h-full flex-1 flex-grow flex-col">
                <div
                  class="flex h-full flex-1 flex-row space-x-5 pb-5 pl-5 pr-5 pt-5"
                >
                  <div
                    class="flex h-full flex-col pb-2"
                    [ngClass]="{
                      'w-2/3': report.chart.series.length > 0,
                      'w-full': report.chart.series.length === 0
                    }"
                  >
                    <div
                      *ngIf="dataPoints.length === 0"
                      class="text-s1 flex h-full w-full select-none items-center justify-center text-xl"
                      >No rows with chart enabled</div
                    >

                    <div
                      *ngIf="
                        dataPoints.length > 0 && selectedDataRowsLength === 0
                      "
                      class="text-s1 flex h-full w-full select-none items-center justify-center text-xl"
                      >No rows with charts enabled</div
                    >

                    <m-chart-box
                      *ngIf="
                        dataPoints.length > 0 &&
                        selectedDataRowsLength > 0 &&
                        recordsWithValuesLength > 0 &&
                        !!eChartInitOpts &&
                        !!eChartOptions
                      "
                      [eChartInitOpts]="eChartInitOpts"
                      [eChartOptions]="eChartOptions"
                      [chartInstanceId]="'metrics-chart'"
                      style="height: 100%"
                    ></m-chart-box>

                    <div
                      *ngIf="
                        dataPoints.length > 0 &&
                        selectedDataRowsLength > 0 &&
                        recordsWithValuesLength === 0
                      "
                      class="text-s1 flex h-full w-full select-none items-center justify-center text-xl"
                    >
                      <div *ngIf="newQueriesLength > 0"
                        >Run queries to get data</div
                      >

                      <div
                        *ngIf="
                          newQueriesLength === 0 && runningQueriesLength > 0
                        "
                        >Queries are running</div
                      >

                      <div
                        *ngIf="
                          newQueriesLength === 0 && runningQueriesLength === 0
                        "
                        >The result has no data</div
                      >
                    </div>
                  </div>

                  <div
                    *ngIf="report.chart.series.length > 0"
                    class="flex h-full w-2/5 flex-shrink-0 flex-col overflow-y-auto border-l"
                    [ngClass]="{
                      'border-s300': report.chart.isValid === true,
                      'border-r600': report.chart.isValid === false
                    }"
                  >
                    <ng-scrollbar
                      [orientation]="'vertical'"
                      [visibility]="'hover'"
                      [appearance]="'compact'"
                    >
                      <m-chart-editor
                        [chart]="report.chart"
                        [isReport]="true"
                        [report]="report"
                        [seriesParts]="seriesParts"
                      ></m-chart-editor>
                    </ng-scrollbar>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="routerEvents$ | async"></div>
<div *ngIf="isAutoRun$ | async"></div>
<div *ngIf="isExplorer$ | async"></div>
<div *ngIf="alias$ | async"></div>
<div *ngIf="report$ | async"></div>
<div *ngIf="reports$ | async"></div>
<div *ngIf="reportChartData$ | async"></div>
<div *ngIf="uiQuery$ | async"></div>
<div *ngIf="struct$ | async"></div>
